import(/* webpackMode: "eager" */ "/home/runner/work/pathfinder-website/pathfinder-website/node_modules/next/dist/client/app-dir/link.js");
